"use client";

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
export default function ALaCarteAndSides() {
  const quesadillas = [{
    id: 1,
    name: "CHEESE ONLY",
    price: "4.75"
  }, {
    id: 2,
    name: "GROUND BEEF",
    price: "6.50"
  }, {
    id: 3,
    name: "SHREDDED CHICKEN",
    price: "6.50"
  }, {
    id: 4,
    name: "SHRIMP",
    price: "7.99"
  }, {
    id: 5,
    name: "GRILLED STEAK",
    price: "7.49"
  }, {
    id: 6,
    name: "MUSHROOM",
    price: "6.99"
  }, {
    id: 7,
    name: "GRILLED CHICKEN",
    price: "7.49"
  }, {
    id: 8,
    name: "CHORIZO",
    price: "6.99"
  }];
  const tacos = [{
    id: 1,
    name: "CHICKEN",
    hard: "3.99",
    soft: "4.25",
    supreme: "4.99"
  }, {
    id: 2,
    name: "BEEF",
    hard: "3.99",
    soft: "4.25",
    supreme: "4.99"
  }];
  const tacoGrill = [{
    id: 1,
    type: "REGULAR",
    price: "4.50"
  }, {
    id: 2,
    type: "SUPREME",
    price: "5.25"
  }];
  const enchiladas = [{
    id: 1,
    name: "CHEESE ONLY",
    price: "4.25"
  }, {
    id: 2,
    name: "BEAN AND CHEESE",
    price: "4.50"
  }, {
    id: 3,
    name: "GROUND BEEF",
    price: "5.25"
  }, {
    id: 4,
    name: "SHREDDED CHICKEN",
    price: "5.25"
  }];
  const burritos = [{
    id: 1,
    name: "GROUND BEEF",
    price: "6.50"
  }, {
    id: 2,
    name: "SHREDDED CHICKEN",
    price: "6.50"
  }, {
    id: 3,
    name: "BEAN AND CHEESE",
    price: "6.25"
  }, {
    id: 4,
    name: "BEEF AND BEAN",
    price: "6.99"
  }, {
    id: 5,
    name: "SHREDDED CHICKEN AND BEAN",
    price: "6.99"
  }, {
    id: 6,
    name: "STEAK OR GRILLED CHICKEN",
    price: "8.50"
  }];
  const chimichangas = [{
    id: 1,
    name: "GROUND BEEF",
    price: "7.50"
  }, {
    id: 2,
    name: "SHREDDED CHICKEN",
    price: "7.50"
  }, {
    id: 3,
    name: "STEAK OR GRILLED CHICKEN",
    price: "8.75"
  }];
  const singleItems = [{
    id: 1,
    name: "CHILE RELLENO",
    price: "5.49"
  }, {
    id: 2,
    name: "CHILES TOREADOS",
    price: "5.49"
  }];
  const nachoCheeseBurrito = {
    name: "NACHO CHEESE BURRITO",
    description: "Beef or Chicken",
    price: "7.49"
  };
  const tamales = {
    name: "TAMALES (1)",
    description: "Corn based dough stuffed with pork, topped with red sauce, ground beef and shredded cheese",
    price: "5.25"
  };
  return;
}